import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';


//import { UserService } from '../../../services/user.service';
import { CommonDataService } from '../../services/common-data.service';
import { environment } from '../../../environments/environment';

declare var $:any;
declare var iziToast:any;

@Component({
  selector: 'app-shop-category-products',
  templateUrl: './shop-category-products.component.html',
  styleUrls: ['./shop-category-products.component.css']
})
export class ShopCategoryProductsComponent implements OnInit {

  pageName = "Shop Products";
  modelName = "Product";
  products: any;
  p: number = 1;
  itemsPerPage = 20;
  displayedProducts = []

  department = {}
  deptName = ""
  category = {}
  subcategories = []
  category_variations_tags = []
  numberOfValidProducts = 0
  categoryId = "0"
  catName = ""
  activeCatVariation = {
    "value": "All",
    "display": "All"
  }

  defaultCatVariation = {
    "value": "All",
    "display": "All"
  }

  subCats = false

  loading = true

  constructor(
    private router: Router,
    private _data: CommonDataService,
    private route: ActivatedRoute
  ) { 


    this.route.params.subscribe((params) => {

      if(params['id']) {
        this.categoryId = params['id'];
      } 
    });

    this.getCategories()
    this.getSubCategories()

    console.log(_data.queryParams);


  }

  ngOnInit() {

    $('#initialise-page').trigger('click');
    $('#owl-initialise').trigger('click');
  }

  getValidProducts() {
    // this.products.sort((a,b)=>a['cover']['model']['modelData']['formFieldsEntities']['productDetails']['name'].localeCompare(b['cover']['model']['modelData']['formFieldsEntities']['productDetails']['name']))
    // return this.products.sort((a,b)=>b['cover']['model']['modelData']['formFieldsEntities']['productDetails']['regular_price'] - a['cover']['model']['modelData']['formFieldsEntities']['productDetails']['regular_price'])

    return this.products.filter(prod => prod['cover']['model']['modelData']['formFieldsEntities']['ProductFlags']['published'] === false);
  }

  clearFilterCategoryVariation() {
    this.activeCatVariation = this.defaultCatVariation

    let cleanList = this.products.filter(prod => prod['cover']['model']['modelData']['formFieldsEntities']['ProductFlags']['published'] === false);
    this.reloadData(cleanList)
  }

  filterCategoryVariation(index) {
    // let keyword = "shoemaker"
    let filteredList = []
    let subCategory = this.subcategories[index]
    let variation = {
      "value": subCategory['cover']['model']['modelData']['formFieldsEntities']['categoryDetails']['name'],
      "display": subCategory['cover']['model']['modelData']['formFieldsEntities']['categoryDetails']['name'],
    }
    this.activeCatVariation = variation

    let subCategoryVariations = subCategory['cover']['model']['modelData']['formFieldsEntities']['categoryDetails']['produc_variations_tags']

    for (let index = 0; index < this.displayedProducts.length; index++) {
      const product = this.displayedProducts[index];

      var productVariations = product['cover']['model']['modelData']['formFieldsEntities']['productDetails']['variations'].split(',')
      var include = false
      for (let index = 0; index < subCategoryVariations.length; index++) {
        const subCategoryVariation = subCategoryVariations[index];
        
        if(productVariations.includes(subCategoryVariation['value'])) {
          include = true
        }
      }

      if(include)
        filteredList.push(product)
      
    }

    // let newList = this.products.filter(prod => prod['cover']['model']['modelData']['formFieldsEntities']['productDetails']['variations'].toLowerCase().indexOf(keyword) > -1);
    this.numberOfValidProducts = filteredList.length
    this.reloadData(filteredList)

  }

  productSelected(details) {

  }

  reloadData(prods) {
    this.displayedProducts = [...prods];
  }

  getCategories() {

    let queryData = new FormData();
    queryData.append('modelName', "ShopCategory");
    queryData.append('mid', this.categoryId);

    this._data.getModelDataShopModels(queryData) 
    .pipe(first())
    .subscribe(
      data => {
        
        if(data['covers'].length > 0) {
          this.category = data['covers'][0]
          this.category_variations_tags = data['covers'][0]['cover']['model']['modelData']['formFieldsEntities']['categoryDetails']['produc_variations_tags']
          // this.activeCatVariation = this.category_variations_tags[0]
          let deptId = data['covers'][0]['cover']['model']['modelData']['formFieldsEntities']['categoryDetails']['store_department']
          // this.category = data['covers'].filter(prod => prod['cover']['model']['modelData']['formFieldsEntities']['categoryDetails']['category_status'] === "active");
          this.catName = data['covers'][0]['cover']['model']['modelData']['formFieldsEntities']['categoryDetails']['name']
          this.getProducts(this.catName)
          this.getDepartments(deptId)
        
        }

        

      },
      error => {
      },

      () => {
          this.getSubCategories()
      }
    );

  }

  getProducts(catName) {
    let queryData = new FormData();
    queryData.append('modelName', this.modelName);
    queryData.append('productDetails->categories', catName);

      $('#loader').show();
      //lets get the model for this page
      this._data.getModelDataShopModels(queryData) 
      .pipe(first())
      .subscribe(
        data => {

          this.products = data['covers'];
          
          if(data['covers'].length > 0) {
            this.displayedProducts = this.getValidProducts()

            this.numberOfValidProducts = this.displayedProducts.length
            
          }

          this.loading = false

        },
        error => {

          console.log(error);
          iziToast.success({
            title: 'Error!',
            position: 'topRight',
            icon: 'icon-circle-check',
            message: 'Failed to get products.'
        });

        $('#loader').hide();

        this.loading = false

        },

        () => {
            $('#loader').hide();
            this.loading = false
        }
      );
  }

  getDepartments(deptId) {

    // $('#loader').show();

    let queryData = new FormData();
    queryData.append('modelName', "Departments");
    queryData.append('mid', deptId);

    //lets get the model for this page
    this._data.getModelDataShopModels(queryData) 
    .pipe(first())
    .subscribe(
      data => {
        
        if(data['covers'].length > 0) {
          this.department = data['covers'][0]
          this.deptName = data['covers'][0]['cover']['model']['modelData']['formFieldsEntities']['departmentDetails']['name']
        }

      },
      error => {},
      () => {
      }
    );
  }
  
  getSubCategories() {

    let queryData = new FormData();
    queryData.append('modelName', "SubCategory");
    queryData.append('categoryDetails->store_department_category', this.categoryId);

    this._data.getModelDataShopModels(queryData) 
    .pipe(first())
    .subscribe(
      data => {
        
        if(data['covers'].length > 0) {
          this.subcategories = data['covers'];

          this.subCats = true
        }

      },
      error => {

      },

      () => {
      }
    );

  }

}
